module.exports = __webpack_public_path__ + "img/logo.ea927b4a.png";